<div class="c-offline">
  <div class="c-offline__title" i18n="@@common.internet_lost">Internet connection lost</div>
  <div class="c-offline__text" i18n="@@common.offline_check_connection">You might be offline. Please, check your connection.</div>
</div>
